import { debug } from '../../.debug.js';

export async function copyToClipboard(textToCopy: string) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(textToCopy);
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    textArea.style.position = 'absolute';
    textArea.style.left = '-999999px';

    document.body.prepend(textArea);
    textArea.select();

    try {
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      document.execCommand('copy');
    } catch (error) {
      debug
        .message('Failed to copy text to clipboard!', { textToCopy }, error)
        .error();
    } finally {
      textArea.remove();
    }
  }
}
